export default __webpack_public_path__ + "static/media/phone.65e884e7.svg";